var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1482_28688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.42857 1.71428V4.28571H14.5714V1.71428H17.1429V4.28571H21V8.14285H3V4.28571H6.85714V1.71428H9.42857ZM3 9.42857H21V22.2857H3V9.42857ZM5.57143 14.5714H8.14286V12H5.57143V14.5714ZM10.7143 12V14.5714H13.2857V12H10.7143ZM18.4286 14.5714V12H15.8571V14.5714H18.4286ZM5.57143 19.7143H8.14286V17.1429H5.57143V19.7143ZM13.2857 17.1429H10.7143V19.7143H13.2857V17.1429ZM15.8571 19.7143H18.4286V17.1429H15.8571V19.7143Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1482_28688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20.5714,
    fill: "white",
    transform: "translate(3 1.71428)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.58e9357b24e6a3c0dd055ab156c48779.svg";
export { ForwardRef as ReactComponent };